import Alert from '~/common/components/Alerts/Alert/Alert';
import AlertDescription from '~/common/components/Alerts/AlertDescription';
import AlertIcon from '~/common/components/Alerts/AlertIcon';
import AlertTitle from '~/common/components/Alerts/AlertTitle';

type GlobalErrorProps = {
  error: string;
};

const GlobalError = ({ error }: GlobalErrorProps) => (
  <Alert status="error">
    <AlertIcon />
    <AlertTitle marginRight="8px">Error:</AlertTitle>
    <AlertDescription>{error}</AlertDescription>
  </Alert>
);

export default GlobalError;
